import axios from "axios";
import { clearAuthSession, getAuthSession } from "../utils/authSession";

const resolveEnvUrl = (envKey, developmentPort) => {
  const value = process.env[envKey];

  if (value) {
    return value;
  }

  if (process.env.NODE_ENV !== "production") {
    return `http://localhost:${developmentPort}/api`;
  }

  throw new Error(`Variavel de ambiente obrigatoria nao configurada: ${envKey}`);
};

const API_URL = resolveEnvUrl("REACT_APP_API_URL", 5000);
const AUTH_API_URL = resolveEnvUrl("REACT_APP_AUTH_API_URL", 5001);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const session = getAuthSession();
  if (session?.access_token) {
    config.headers.Authorization = `Bearer ${session.access_token}`;
  }

  const requestUrl = config.url || "";
  if (AUTH_API_URL && requestUrl.startsWith("/auth/")) {
    config.baseURL = AUTH_API_URL;
  }

  return config;
});

api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 401) {
        const requestUrl = error.config?.url || "";

        if (
          !requestUrl.includes("/auth/login") &&
          !requestUrl.includes("/auth/refresh") &&
          !requestUrl.includes("/auth/me")
        ) {
          clearAuthSession();
          window.location.href = "/login";
        }
      }

      let errorMessage = "";

      if (typeof data.messages === "object" && data.messages !== null) {
        errorMessage = Object.entries(data.messages)
          .map(([key, value]) =>
            `${key}: ${Array.isArray(value) ? value.join("; ") : value}`
          )
          .join("\n");
      } else {
        errorMessage = data.message || "Erro na requisicao";
      }

      return Promise.reject({ message: errorMessage });
    } else if (error.request) {
      return Promise.reject({
        message: "Erro de rede. Verifique sua conexao com a internet.",
      });
    } else {
      return Promise.reject({
        message: "Erro na configuracao da requisicao.",
      });
    }
  }
);

export default api;
